import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAddSendOutCollectionMutation } from "store/services/sendOutCollectionApi"; 
import SendOutCollectionForm from "./SendOutCollectionComponent/SendOutCollectionForm";

const SendOutCollectionCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Send Out Collection", path: "/app/crm/sendOutCollection/list" },
    { title: "New Send Out Collection" },
  ];

  const [createSendOutCollection, { isLoading: creatingSendOutCollection }] = useAddSendOutCollectionMutation();

  const handleAddSendOutCollection = async (data) => {
    try {
      const { _id } = await createSendOutCollection(data).unwrap();
      toast.success("Send Out Collection Created!");
      navigate(`/app/crm/sendOutCollection/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could not create Send Out Collection!"
      );
    }
  };

  useAppMeta("New Send Out Collection");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingSendOutCollection}>
      <BreadcrumbLayout.Paper>
        <SendOutCollectionForm
          isBusy={creatingSendOutCollection}
          onSubmit={handleAddSendOutCollection}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default SendOutCollectionCreateScreen;
